import React, { useState, useEffect } from 'react';
import { listPending, getAppointment, deleteAppointment } from '../../logic/calendar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Col, Row } from 'react-bootstrap';

function PendingAppointments() {
	const navigate = useNavigate();
	const [appointmentList, setAppointmentList] = useState([]);
	
	useEffect(() => {
		async function fetchData() {
			try {
				const docId = window.localStorage.getItem('currentDoctorId');
				const list = await listPending(docId);
				setAppointmentList(list);
			} catch (e) {
				console.log(e);
			}
		}
		
		fetchData();
	}, []);
	
	const handleImport = async (docId, creationTimestamp) => {
		try {
			const item = await getAppointment(docId, creationTimestamp);
			navigate(`/appointments/${creationTimestamp}`, {
				state: { item }
			});
		} catch (e) {
			console.log(e);
		}
	};
	
	const handleDelete = async (creationTimestamp) => {
		if (window.confirm('Delete this pending appointment?')) {
			const app = await deleteAppointment(window.localStorage.getItem('currentDoctorId'), creationTimestamp);

			if (app instanceof Error)
				console.log(app);
			else
				navigate("/");
		}
	};
	
	return (
		<div>
			<div className="pages__back-button--container">
				<FontAwesomeIcon className="pages__back-button--icon" icon="chevron-left"></FontAwesomeIcon>
				<Link className="pages__back-button--text" to="/appointments/new">Back</Link>
			</div>
			<header className="pages__header--container centered-text">
				<h1>Pending Appointments List</h1>
			</header>
			<div className="medium-push"></div>
			<Container className="pending__container">
				{
					appointmentList && appointmentList.length >= 1 ?
						appointmentList.map((item, i) => {
							return (
								<Row key={i} className="pending__container--item" onClick={() => handleImport(item.docId, item.creationTimestamp)}>
									<Col xs={3} sm={3} md={3} lg={3}>
										<Row className="pending__text--name">{item.patient.name.firstName}&nbsp;{item.patient.name.lastName}</Row>
										<Row>{item.patient.idCard}</Row>
									</Col>
									<Col xs={8} sm={8} md={8} lg={8}>
										<Row>
											{
												item.pharmacyRemarks && item.pharmacyRemarks.length > 0 ?
													<p>Medicaid Remarks&nbsp;-&nbsp;{item.pharmacyRemarks}</p>
													: <p className="pending__text--no-comments">No Comments</p>
											}
										</Row>
									</Col>
									<Col xs={1} sm={1} md={1} lg={1}>
										<Row>
											<div className="settings__list--actionIcons">
												<FontAwesomeIcon onClick={(e) => {
													e.stopPropagation();
													handleDelete(item.creationTimestamp);
												}} className="pending__list--delete" icon="trash-alt" />
											</div>
										</Row>
									</Col>
								</Row>
							)
						})
						: <div className="settings__list--no-tasks-container">
							<p className="settings__list--no-tasks-text">This doctor does not have any pending appointments.</p>
						</div>
				}
			</Container>
		</div>
	);
}

export default PendingAppointments;